import React, { FC } from 'react';
import {
  SettlementInSearchTrip,
  SettlementStatus
} from '../../../../redux/api/settlement/settlement.model';
import Box from '@mui/material/Box';
import StringUtils from '../../../../utils/stringUtils';
import { TwButton, TwButtonType } from '../../../TwButtons/TwButtons';
import { TripDriver } from '../../../../redux/api/trips/trips.model';
import useAuth from '../../../../providers/Auth/Auth.provider';
import { USER_ROLE } from '../../../../providers/User/User.model';

interface SettlementStatusProps {
  settlements: SettlementInSearchTrip[];
  drivers: TripDriver[];
}

const SettlementStatusLabels: FC<SettlementStatusProps> = ({
  settlements,
  drivers
}): JSX.Element => {
  const {
    data: { userData }
  } = useAuth();

  const isAdminOrOwner = userData?.role === USER_ROLE.ADMIN || userData?.role === USER_ROLE.OWNER;

  const openSettlementInNewTab = (settlementId: string): void => {
    window.open(`/settlements/view/${settlementId}`, '_blank');
  };
  const hasOwnerOperatorSettlement = settlements.some((settlement) => settlement.owner_operator_id);

  if (settlements.length === 0 || drivers.length === 0) {
    return <Box className="load-detail__data-container__overview__client-load">Not started</Box>;
  }

  return (
    <Box
      component="div"
      className="load-detail__data-container__overview__settlement-status-container"
    >
      {' '}
      {hasOwnerOperatorSettlement
        ? settlements.map((settlement, i) => {
            return (
              <Box
                key={settlement.id}
                className="load-detail__data-container__overview__settlement-status"
              >
                {StringUtils.showSettlementStatusLabel(settlement.status)}
                {settlement.status === SettlementStatus.PAID && isAdminOrOwner && (
                  <TwButton
                    label="View details"
                    action={(): void => openSettlementInNewTab(settlement.id)}
                    type={TwButtonType.text}
                  />
                )}
              </Box>
            );
          })
        : drivers.map((driver) => {
            const driverSettl = settlements.find(
              (settlement) => settlement.driver_id === driver.id
            );

            return (
              <Box
                key={driver.id}
                className="load-detail__data-container__overview__settlement-status"
              >
                {`${
                  driverSettl
                    ? StringUtils.showSettlementStatusLabel(driverSettl.status)
                    : 'Not started'
                } - ${driver.first_name} ${driver.last_name}`}
                {driverSettl && driverSettl.status === SettlementStatus.PAID && isAdminOrOwner && (
                  <TwButton
                    label="View details"
                    action={(): void => openSettlementInNewTab(driverSettl.id)}
                    type={TwButtonType.text}
                  />
                )}
              </Box>
            );
          })}
    </Box>
  );
};

export default SettlementStatusLabels;
